import Categories from "template-store/constants/categories";
import urljoin from "url-join";
const DEFAULT_DEMO_CLOUDINARY_ROOT_FOLDER = "https://dapulse-res.cloudinary.com/video/upload/mondayhomepage/template-store/feature_videos/";
const CATEGORY_DEMO_VIDEOS_FOLDER = {
    [Categories.MARKETING]: "marketing",
    [Categories.PROJECT_MANAGEMENT]: "project_management",
    [Categories.CRM]: "crm",
    [Categories.SOFTWARE_DEVELOPMENT]: "software_development",
    [Categories.HR]: "hr",
    [Categories.DESIGN]: "design",
    [Categories.CONTENT_PRODUCTION]: "content_production",
    [Categories.FREELANCERS]: "freelancers",
    [Categories.OPERATIONS]: "office_operations",
    [Categories.STARTUP]: "startup",
    [Categories.EDUCATION]: "education",
    [Categories.REAL_ESTATE]: "real_estate",
    [Categories.CONSTRUCTION]: "construction"
};
export const getCategoryData = (categories, categoryId)=>{
    return categories.find((category)=>category.value === categoryId);
};
export const getCategoriesData = (categories, categoryIds)=>{
    return categories.filter((category)=>categoryIds === null || categoryIds === void 0 ? void 0 : categoryIds.includes(category.value));
};
export const getFeaturedCategories = (categories)=>{
    const featuredCategoriesIds = [
        Categories.MARKETING,
        Categories.PROJECT_MANAGEMENT,
        Categories.CRM,
        Categories.SOFTWARE_DEVELOPMENT,
        Categories.HR,
        Categories.DESIGN
    ];
    const featuredCategories = categories.filter((category)=>featuredCategoriesIds.includes(category.value));
    return featuredCategories;
};
export const getBannerDescriptionKeyForCategory = (category_id)=>{
    return `templateCenter.category.description.${category_id}`;
};
export const getBannerTitleKeyForCategory = (category_id)=>{
    return `templateCenter.category.title.${category_id}`;
};
export const getCategoryName = (categoryData)=>{
    return categoryData === null || categoryData === void 0 ? void 0 : categoryData.label;
};
export const getCategoryId = (categoryData)=>{
    return categoryData === null || categoryData === void 0 ? void 0 : categoryData.value;
};
export const getCloudinartDemoVideoURLForCategory = (categoryId, fileName)=>{
    let rootFolder = DEFAULT_DEMO_CLOUDINARY_ROOT_FOLDER;
    const categoryFolder = CATEGORY_DEMO_VIDEOS_FOLDER[categoryId];
    if (!!categoryFolder) {
        rootFolder = urljoin(rootFolder, categoryFolder);
    }
    return urljoin(rootFolder, fileName);
};
